<!--
Copyright 2024 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->
<section class="scrolling-region">
  <table mat-table #injectTable [dataSource]="injectDataSource" matSort multiTemplateDataRows>
    <!-- action column -->
    <ng-container matColumnDef="action">
      <mat-header-cell *matHeaderCellDef [ngClass]="isEditMode ? 'mat-column-action' : 'mat-column-select'">
        <!-- In Catalog -->
        @if (canEdit && catalog.id) {
        <button mat-icon-button [matMenuTriggerFor]="addMenu" style="outline: none;" title="Add Inject">
          <mat-icon class="mdi-24px self-center" fontIcon="mdi-plus-circle"></mat-icon>
        </button>
        }
        <mat-menu #addMenu="matMenu" [overlapTrigger]="false">
          <button mat-menu-item (click)="addInject()" title="Add a new inject">New Inject</button>
          <button mat-menu-item [matMenuTriggerFor]="addExistingInject" title="Add an existing inject">
            Add Existing Inject
          </button>
        </mat-menu>
        <mat-menu #addExistingInject="matMenu" [overlapTrigger]="false">
          @for (catalog of getFilteredCatalogs(); track catalog) {
          <button mat-menu-item (click)="selectExisting(catalog)" title="{{ catalog.name }}">
            {{ catalog.name }}
          </button>
          }
          <button mat-menu-item (click)="selectExisting(null)" title="All Injects of Type">
            All Injects of Type
          </button>
        </mat-menu>
      </mat-header-cell>
      <mat-cell *matCellDef="let element" [ngClass]="isEditMode ? 'mat-column-action' : 'mat-column-select'">
        @if (isEditMode) {
        <div>
          @if (canEdit) {
          <button mat-icon-button class="msel-action" (click)="editInject(element)"
            title="Edit {{ element.name }} inject">
            <mat-icon class="mdi-18px" fontIcon="mdi-square-edit-outline"
              title="Edit {{ element.name }} inject"></mat-icon>
          </button>
          }
          @if (canEdit) {
          <button mat-icon-button (click)="copyInject(element)" title="Copy {{ element.name }}">
            <mat-icon class="mdi-18px" fontIcon="mdi-content-copy" alt="Copy"></mat-icon>
          </button>
          }
          @if (canEdit) {
          <button mat-icon-button class="msel-action" (click)="deleteInject(element)"
            title="Delete {{ element.name }} inject">
            <mat-icon class="mdi-18px" fontIcon="mdi-trash-can-outline"
              title="Delete {{ element.name }} inject"></mat-icon>
          </button>
          }
        </div>
        }
        @if (!isEditMode) {
        <div>
          <mat-checkbox [checked]="isSelected(element.id)" (change)="select(element, $event)"></mat-checkbox><br />
        </div>
        }
      </mat-cell>
    </ng-container>
    <!-- name Column -->
    <ng-container matColumnDef="name">
      <mat-header-cell title="Inject Name" *matHeaderCellDef>
        Name
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.name }}
      </mat-cell>
    </ng-container>
    <!-- description Column -->
    <ng-container matColumnDef="description">
      <mat-header-cell title="Inject Description" *matHeaderCellDef>
        Description
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{ element.description }}
      </mat-cell>
    </ng-container>
    <!-- datafield Columns -->
    @for (df of getDisplayedDataFields(); track df.id) {
    <ng-container matColumnDef="{{ df.name }}">
      <mat-header-cell title="{{ df.name }}" *matHeaderCellDef>
        {{ df.name }}
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        <app-data-value [(value)]="getDataValue(element, df).value" [dataField]="df" [canEdit]="false"
          [canApprove]="false" [isOwner]="false" [showValueOnly]="true" [organizationOptions]="[]" [teamOptions]="[]"
          [unitOptions]="unitList" [cardOptions]="[]" [moveOptions]="[]" [gallerySourceTypeOptions]="[]"
          [userOptions]="userList"></app-data-value>
      </mat-cell>
    </ng-container>
    }
    <!-- row definitions -->
    <mat-header-row *matHeaderRowDef="getDisplayedColumns()"></mat-header-row>
    <mat-row *matRowDef="let row; columns: getDisplayedColumns();"></mat-row>
  </table>
  <!-- No Results Message -->
  @if (injectDataSource?.filteredData.length === 0) {
  <div class="no-results">No Injects found</div>
  }
</section>
